import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as ReviewsActions from './reviews.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class ReviewsStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new ReviewsActions.ReviewsRefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.REVIEWS, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new ReviewsActions.ReviewsCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new ReviewsActions.ReviewsUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new ReviewsActions.ReviewsDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new ReviewsActions.ReviewsRefresh());
          break;

        case SignalRAction.RequestRefresh:
          this.store.dispatch(new ReviewsActions.ReviewsRefreshById(data.id));
          break;
      }
    });
  }
}
